import React, { useEffect } from 'react'
import Footer from 'src/components/Footer/Footer'
import NoticeDetailsContent from 'src/components/NoticesContent/OpportunitiesDetails/OpportunitiesDetailsContent'
import Navbar from 'src/components/Navbar/Navbar'

const OpportunitiesDetailsPage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [])

  return (
    <>
      <Navbar />
      <NoticeDetailsContent />
      <Footer />
    </>
  )
}

export default OpportunitiesDetailsPage
